// extracted by mini-css-extract-plugin
module.exports = {"ThoundsSongs":"_1d-0EdA8jARyTZG1PSvQ7b"};